export default {
	title: "Support",
	newTicket: "New Ticket",
	ticketDetail: "Ticket Details",
	subject: "Subject",
	description: "Description",
	category: "Category",
	noTickets: "No tickets found",
	noTicketsDescription: "You haven't opened any support tickets yet",
	comments: "Comments",
	replyPlaceholder: "Type your reply...",
	send: "Send",
	createdAt: "Opened at",
	updatedAt: "Updated at",
	backToList: "Back to tickets",
	totalTickets: "Total",
	openTickets: "Open",
	attachImage: "Attach image",
	categories: {
		BUG: "Bug",
		FEATURE: "Suggestion",
		QUESTION: "Question",
	},
	status: {
		OPEN: "Open",
		IN_PROGRESS: "In Progress",
		RESOLVED: "Resolved",
		CLOSED: "Closed",
	},
	messages: {
		ticketCreated: "Ticket created successfully",
		commentAdded: "Reply sent successfully",
		errorCreating: "Error creating ticket",
		errorLoading: "Error loading tickets",
		errorAddingComment: "Error sending reply",
		imageTooLarge: "Image too large. Maximum size: 5MB",
	},
	table: {
		headers: {
			subject: "Subject",
			category: "Category",
			status: "Status",
			date: "Date",
			comments: "Replies",
		},
	},
};
